import React from "react";
import {
    Content,
    ContentVariants
} from "@patternfly/react-core";
import { getMediaUrl } from "../../../utils/media";

export const SheetAnswerKeyCell = ({ row, props, context }) => {
  const answerKeyUrl = row?.raw?.answer_key_url;
  const answerKeytName = row?.answer_key || "Brak nazwy";

  const answerKeyUrlExists = Boolean(answerKeyUrl);
  const isPublic = row.raw?.visibility === "public";
  const isAuthVisible = 
    (row.raw?.visibility === "authenticated" && context.state.isAuthUser) || 
    (row.raw?.visibility === "restricted" && context.state.userProfile.is_superuser);

  // clickable tylko gdy URL istnieje i użytkownik ma dostęp
  const clickable = answerKeyUrlExists && (isPublic || isAuthVisible);
  const cursorStyle = clickable ? "pointer" : "default";
  const colorStyle = clickable ? undefined : "gray";

  const regex = /\/sheets\/.*\/answer/;
  const downloadUrl = answerKeyUrl
    ? regex.test(answerKeyUrl) // jeśli nowa struktura
      ? `${props.state.api_url}${answerKeyUrl}`  // nowy URL
      : `${props.state.api_url}/${props.state.django_media_dir}/${answerKeyUrl}` // stara struktura
    : null;

  const answerKeytNameNew = answerKeytName
    ? regex.test(answerKeyUrl) // jeśli nowa struktura
      ? `${answerKeyUrl}`  // nowy URL
      : `${props.state.api_url}/${props.state.django_media_dir}/${answerKeyUrl}` // stara struktura
    : null;
  
  const handleDownload = (type) => {
    if (!answerKeyUrl) return;

    // jeśli nowy secure URL lub typ pliku, który ma być wyświetlany w przeglądarce
    const forceOpenInBrowser = type === "answer";

    if (forceOpenInBrowser) {
      window.open(downloadUrl, "_blank");
      return;
    }
    getMediaUrl(
      downloadUrl,
      answerKeytNameNew
    );
  };
  return (
    <>
      {row.answer_key_url &&
        <Content 
          component={ContentVariants.a}
          target="_blank"
          style={{
            color: colorStyle,
            cursor: cursorStyle 
          }}
          onClick={clickable? () => handleDownload("answer"): undefined}
        >
          [Zobacz]
        </Content>
      }
    </>
  );
};